import { bl_applet_to_catalog_plugin_link_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class AppletToCatalogPluginLinksContainerModel extends BaseContainerModel {
    bl_applet_to_catalog_plugin_link: bl_applet_to_catalog_plugin_link_RowClass;
}